var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, useStepper } from "@opala-ds/react";
import React, { useMemo, useRef, useState } from "react";
import { useQueryClient } from "@tanstack/react-query";
import ReCAPTCHA from "react-google-recaptcha";
export default function FormActions() {
    var _a = useStepper(), previousStep = _a.previousStep, currentStep = _a.currentStep, steps = _a.steps;
    var queryClient = useQueryClient();
    var recaptchaRef = useRef(null);
    var _b = useState(false), isVerified = _b[0], setIsVerified = _b[1];
    function handleVerifyChange() {
        setIsVerified(function (prevState) { return !prevState; });
    }
    var isFirstStep = useMemo(function () { return currentStep === 0; }, [currentStep]);
    var isLastStep = useMemo(function () { return currentStep === steps.length - 1; }, [currentStep, steps.length]);
    var isMutating = queryClient.isMutating() > 0;
    return (_jsxs("div", __assign({ className: "flex flex-col md:flex-row gap-4 py-4 items-end" }, { children: [isFirstStep || (_jsx(Button, __assign({ disabled: isMutating, className: "w-full md:w-max px-14 md:px-16", type: "button", variant: "outline", onClick: previousStep }, { children: "Voltar" }))), !isLastStep && (_jsx(Button, __assign({ className: "w-full md:w-max px-14 ml-auto", type: "submit" }, { children: "Avan\u00E7ar" }))), isLastStep && (_jsxs("div", __assign({ className: "w-full md:w-auto flex flex-col md:flex-row gap-4 items-center md:items-end md:ml-auto" }, { children: [_jsx(ReCAPTCHA, { ref: recaptchaRef, sitekey: "6Lf1wlwnAAAAABXuwppJEzCvV_NIdD2lXZL9gbyj", onChange: handleVerifyChange }), _jsx(Button, __assign({ isLoading: isMutating && isLastStep, disabled: isMutating || !isVerified, className: "w-full md:w-max px-14", type: "submit" }, { children: "Concluir" }))] })))] })));
}
